<template>
  <div id="toastRoot">
    <div id="toastContainer">
      <div style="display: flex;justify-content: center;align-items: center;width: 100%;height: 4vw;flex-direction: column;font-size: 1.2vw;color: white;">
        {{$store.state.toastMessage}}
      </div>
    </div>
  </div>
 </template>
 
 <script>
  export default {
    data () {
      return {}
    },
    components: {
    },
    methods:{
      
    },
    created:function(){
      setTimeout(() => {
        let payload = {"showOrHide": false, "toastMessage": "无"}
        this.$store.commit("switchToast",payload)
      }, 1200);
    }
  }
 </script>
 
 <style>
#toastRoot{
    /* display: none; */
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    /* background: rgba(51,51,51,0.5); */
    z-index: 4233;
  }
  #toastContainer{
    width: auto;
    min-width: 60vw;
    max-width: 100vw;
    height: auto;
    min-height: 5vw;
    position: absolute;
    top: 80%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #EEA33B;
    z-index: 4255;
    border-radius: 20px 20px 20px 20px;
  }

 </style>


// WEBPACK FOOTER //
// src/Toast.vue